<template>
    <div>
        <table
            v-for="childParentIncome in childParentIncomes"
            :key="childParentIncome.id"
            class="kgr-table kgr-table--block kgr-table--striped kgr-row"
        >
            <thead>
                <tr
                    v-if="childParentIncome.isHighestRateNone()"
                    class="kgr-table__row toggle"
                >
                    <th
                        colspan="3"
                        class="kgr-table__cell"
                    >
                        <a
                            class="kgr-link"
                            @click="toggle(childParentIncome.id)"
                        >
                            <span v-if="isExpanded(childParentIncome.id)">{{ $t('Tabelle ausblenden') }}</span>
                            <span v-else>{{ $t('Tabelle einblenden') }}</span>
                        </a>
                    </th>
                </tr>
                <tr class="kgr-table__row">
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Gültig ab') }} {{ childParentIncome.start }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('childParentIncome.createdAt') }} {{ childParentIncome.created }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t(`childParentIncome.status.${childParentIncome.status}`) }}
                    </th>
                </tr>
                <tr class="kgr-table__row">
                    <th
                        class="kgr-table__cell kgr-table__cell--headline"
                        colspan="3"
                    >
                        {{ $t('Höchstsatz') }}
                    </th>
                </tr>
                <tr class="kgr-table__row">
                    <td
                        class="kgr-table__cell"
                        colspan="3"
                    >
                        <kgr-child-parent-income-highest-rate
                            :value="childParentIncome.highestRate"
                            :disabled="true"
                        />
                    </td>
                </tr>
            </thead>
            <template v-if="isExpanded(childParentIncome.id) && childParentIncome.isHighestRateNone()">
                <tbody>
                    <tr class="kgr-table__row">
                        <td
                            class="kgr-table__cell kgr-table__cell--headline"
                            colspan="3"
                        >
                            {{ $t('Einkommensbestandteile') }}
                        </td>
                    </tr>
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Einkommensteuerbescheid')"
                        :value1="childParentIncome.parentIncome1.incomeTaxAssessment"
                        :value2="childParentIncome.parentIncome2.incomeTaxAssessment"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Jahresbruttoeinkommen (elek. Lohnsteuerbescheinigung)')"
                        :value1="childParentIncome.parentIncome1.grossAnnualIncome"
                        :value2="childParentIncome.parentIncome2.grossAnnualIncome"
                        class-name="highlight"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Einkünfte aus Land-, Forstwirtschaft sowie Gewerbebetrieb')"
                        :value1="childParentIncome.parentIncome1.incomeAgricultureForestryAndCommercial"
                        :value2="childParentIncome.parentIncome2.incomeAgricultureForestryAndCommercial"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Einkünfte aus Kapitalvermögen (Zinsen, Dividende etc.)')"
                        :value1="childParentIncome.parentIncome1.incomeCapitalAssets"
                        :value2="childParentIncome.parentIncome2.incomeCapitalAssets"
                        class-name="highlight"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Einkünfte aus Vermietung und Verpachtung')"
                        :value1="childParentIncome.parentIncome1.incomeRentalAndLeasing"
                        :value2="childParentIncome.parentIncome2.incomeRentalAndLeasing"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('wegen Geringfügigkeit pauschal versteuerte Einkommen')"
                        :value1="childParentIncome.parentIncome1.incomeTaxedDueToInsignificance"
                        :value2="childParentIncome.parentIncome2.incomeTaxedDueToInsignificance"
                        class-name="highlight"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Renten')"
                        :value1="childParentIncome.parentIncome1.pensions"
                        :value2="childParentIncome.parentIncome2.pensions"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Unterhaltsleistungen für die Personensorgeberechtigten')"
                        :value1="childParentIncome.parentIncome1.maintenanceServicesForCustodians"
                        :value2="childParentIncome.parentIncome2.maintenanceServicesForCustodians"
                        class-name="highlight"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Kindesunterhalt bzw. Unterhaltsvorschuss')"
                        :value1="childParentIncome.parentIncome1.childSupport"
                        :value2="childParentIncome.parentIncome2.childSupport"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Sonstiges')"
                        :value1="childParentIncome.parentIncome1.incomeOthers"
                        :value2="childParentIncome.parentIncome2.incomeOthers"
                        class-name="highlight"
                    />
                    <tr class="kgr-table__row">
                        <td
                            class="kgr-table__cell kgr-table__cell--headline"
                            colspan="3"
                        >
                            {{ $t('Einnahmen nach dem SGB III Arbeitsförderung und nach dem SGB II Grundsicherung') }}
                        </td>
                    </tr>
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Arbeitslosengeld')"
                        :value1="childParentIncome.parentIncome1.unemploymentBenefit"
                        :value2="childParentIncome.parentIncome2.unemploymentBenefit"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('ALG II')"
                        :value1="childParentIncome.parentIncome1.alg2"
                        :value2="childParentIncome.parentIncome2.alg2"
                        class-name="highlight"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('BAföG')"
                        :value1="childParentIncome.parentIncome1.bafoeg"
                        :value2="childParentIncome.parentIncome2.bafoeg"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Asylbewerberleistungen (AsylbLG)')"
                        :value1="childParentIncome.parentIncome1.asylumSeekerBenefits"
                        :value2="childParentIncome.parentIncome2.asylumSeekerBenefits"
                        class-name="highlight"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Sonstiges')"
                        :value1="childParentIncome.parentIncome1.incomeOthersSgb"
                        :value2="childParentIncome.parentIncome2.incomeOthersSgb"
                    />
                    <tr class="kgr-table__row">
                        <td
                            class="kgr-table__cell kgr-table__cell--headline"
                            colspan="3"
                        >
                            {{ $t('Sonstige Leistungen nach anderen Sozialgesetzen') }}
                        </td>
                    </tr>
                    <kgr-child-parent-income-list-table-row
                        :label="$t('§ 32b EstG')"
                        :value1="childParentIncome.parentIncome1.benefitsParagraph32bEstG"
                        :value2="childParentIncome.parentIncome2.benefitsParagraph32bEstG"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Wohngeld')"
                        :value1="childParentIncome.parentIncome1.housingBenefit"
                        :value2="childParentIncome.parentIncome2.housingBenefit"
                        class-name="highlight"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Krankengeld')"
                        :value1="childParentIncome.parentIncome1.sicknessBenefit"
                        :value2="childParentIncome.parentIncome2.sicknessBenefit"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Mutterschaftsgeld')"
                        :value1="childParentIncome.parentIncome1.maternityBenefit"
                        :value2="childParentIncome.parentIncome2.maternityBenefit"
                        class-name="highlight"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Elterngeld')"
                        :value1="childParentIncome.parentIncome1.parentalBenefit"
                        :value2="childParentIncome.parentIncome2.parentalBenefit"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Kindergeld')"
                        :value1="childParentIncome.parentIncome1.childBenefit"
                        :value2="childParentIncome.parentIncome2.childBenefit"
                        class-name="highlight"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Sonstiges')"
                        :value1="childParentIncome.parentIncome1.otherServicesDueToSocialLaws"
                        :value2="childParentIncome.parentIncome2.otherServicesDueToSocialLaws"
                    />
                    <tr class="kgr-table__row">
                        <td
                            class="kgr-table__cell kgr-table__cell--headline"
                            colspan="3"
                        >
                            {{ $t('Einkommen aus selbständiger Arbeit') }}
                        </td>
                    </tr>
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Geschätztes Einkommen')"
                        :value1="childParentIncome.parentIncome1.incomeFromSelfEmploymentEstimated"
                        :value2="childParentIncome.parentIncome2.incomeFromSelfEmploymentEstimated"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Einkommen laut Steuerbescheid')"
                        :value1="childParentIncome.parentIncome1.incomeFromSelfEmploymentAccordingToTaxAssessment"
                        :value2="childParentIncome.parentIncome2.incomeFromSelfEmploymentAccordingToTaxAssessment"
                        class-name="highlight"
                    />
                    <tr class="kgr-table__row">
                        <td
                            class="kgr-table__cell kgr-table__cell--headline"
                            colspan="3"
                        >
                            {{ $t('Einkommensminderung') }}
                        </td>
                    </tr>
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Unterhaltszahlungen')"
                        :value1="childParentIncome.parentIncome1.incomeDecreaseByAlimonyPayments"
                        :value2="childParentIncome.parentIncome2.incomeDecreaseByAlimonyPayments"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Werbekosten')"
                        :value1="childParentIncome.parentIncome1.incomeDecreaseByAdvertisingCosts"
                        :value2="childParentIncome.parentIncome2.incomeDecreaseByAdvertisingCosts"
                        class-name="highlight"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Lohnsteuer')"
                        :value1="childParentIncome.parentIncome1.incomeDecreaseByIncomeTax"
                        :value2="childParentIncome.parentIncome2.incomeDecreaseByIncomeTax"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Solidaritätszuschlag')"
                        :value1="childParentIncome.parentIncome1.incomeDecreaseBySolidaritySurcharge"
                        :value2="childParentIncome.parentIncome2.incomeDecreaseBySolidaritySurcharge"
                        class-name="highlight"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Kirchensteuer')"
                        :value1="childParentIncome.parentIncome1.incomeDecreaseByChurchTax"
                        :value2="childParentIncome.parentIncome2.incomeDecreaseByChurchTax"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Arbeitnehmeranteil Rentenversicherung')"
                        :value1="childParentIncome.parentIncome1.incomeDecreaseByEmployeeContributionPensionInsurance"
                        :value2="childParentIncome.parentIncome2.incomeDecreaseByEmployeeContributionPensionInsurance"
                        class-name="highlight"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Arbeitnehmeranteil Krankenversicherung')"
                        :value1="childParentIncome.parentIncome1.incomeDecreaseByEmployeeContributionHealthInsurance"
                        :value2="childParentIncome.parentIncome2.incomeDecreaseByEmployeeContributionHealthInsurance"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Arbeitnehmeranteil Pflegeversicherung')"
                        :value1="childParentIncome.parentIncome1.incomeDecreaseByEmployeeContributionNursingCareInsurance"
                        :value2="childParentIncome.parentIncome2.incomeDecreaseByEmployeeContributionNursingCareInsurance"
                        class-name="highlight"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Arbeitnehmeranteil Arbeitslosenversicherung')"
                        :value1="childParentIncome.parentIncome1.incomeDecreaseByEmployeeContributionUnemploymentInsurance"
                        :value2="childParentIncome.parentIncome2.incomeDecreaseByEmployeeContributionUnemploymentInsurance"
                    />
                    <kgr-child-parent-income-list-table-row
                        :label="$t('Abzug Sonstige')"
                        :value1="childParentIncome.parentIncome1.incomeDecreaseByOther"
                        :value2="childParentIncome.parentIncome2.incomeDecreaseByOther"
                        class-name="highlight"
                    />
                </tbody>
                <tfoot>
                    <tr class="kgr-table__row sum">
                        <td class="kgr-table__cell label">
                            {{ $t('Gesamteinkommen je Elternteil') }}
                        </td>
                        <td class="kgr-table__cell">
                            <kgr-money :value="childParentIncome.sumIncome1()" />
                        </td>
                        <td class="kgr-table__cell">
                            <kgr-money :value="childParentIncome.sumIncome2()" />
                        </td>
                    </tr>
                    <tr class="kgr-table__row sum">
                        <td class="kgr-table__cell label">
                            {{ $t('Gesamteinkommen') }}
                        </td>
                        <td
                            class="kgr-table__cell"
                            colspan="2"
                        >
                            <kgr-money :value="childParentIncome.sum()" />
                        </td>
                    </tr>
                    <tr v-if="childParentIncome.isActive()">
                        <td
                            colspan="3"
                            class="button"
                        >
                            <kgr-button
                                :value="$t('PDF zur Festsetzung des Elternbeitrages erzeugen')"
                                @click="createContribution(childParentIncome.id)"
                            />
                            <kgr-button
                                :value="$t('invalidate')"
                                type="red"
                                :pending="isPending(childParentIncome.id)"
                                @click="onInvalidate(childParentIncome.id)"
                            />
                        </td>
                    </tr>
                </tfoot>
            </template>
            <tfoot v-else-if="childParentIncome.isHighestRateNone()">
                <tr class="kgr-table__row sum">
                    <td class="kgr-table__cell label">
                        {{ $t('Gesamteinkommen') }}
                    </td>
                    <td colspan="2">
                        <kgr-money :value="childParentIncome.sum()" />
                    </td>
                </tr>
                <tr v-if="childParentIncome.isActive()">
                    <td
                        colspan="3"
                        class="button"
                    >
                        <kgr-button
                            :value="$t('PDF zur Festsetzung des Elternbeitrages erzeugen')"
                            @click="createContribution(childParentIncome.id)"
                        />
                        <kgr-button
                            :value="$t('invalidate')"
                            type="red"
                            :pending="isPending(childParentIncome.id)"
                            @click="onInvalidate(childParentIncome.id)"
                        />
                    </td>
                </tr>
            </tfoot>
            <tfoot v-else>
                <tr v-if="childParentIncome.isActive()">
                    <td
                        colspan="3"
                        class="button"
                    >
                        <kgr-button
                            :value="$t('PDF zur Festsetzung des Elternbeitrages erzeugen')"
                            @click="createContribution(childParentIncome.id)"
                        />
                        <kgr-button
                            :value="$t('invalidate')"
                            type="red"
                            :pending="isPending(childParentIncome.id)"
                            @click="onInvalidate(childParentIncome.id)"
                        />
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import ChildParentIncomeHighestRate from './ChildParentIncomeHighestRate';
import ChildParentIncomeListTableRow from './ChildParentIncomeListTableRow';
import ChildParentIncomeRepository from '../../../js/repository/ChildParentIncomeRepository';
import KgrButton from '../../common/form/button/KgrButton';
import KgrMoney from '../../common/convert/Money';

export default {
    components: {
        'kgr-child-parent-income-list-table-row': ChildParentIncomeListTableRow,
        'kgr-child-parent-income-highest-rate': ChildParentIncomeHighestRate,
        'kgr-button': KgrButton,
        'kgr-money': KgrMoney,
    },
    props: {
        childParentIncomes: {
            type: Array,
            required: true,
            default: () => [],
        },
        childId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            pendingId: null,
            expandedIds: [],
        };
    },
    mounted() {
        this.initExpandedIds();
    },
    methods: {
        redirectToShow() {
            window.location = `/backend/child/${this.childId}/child-parent-income`;
        },
        createContribution(childParentIncomeId) {
            window.location = `/backend/child/${this.childId}/child-parent-contribution/${childParentIncomeId}`;
        },
        onInvalidate(childParentIncomeId) {
            this.pendingId = childParentIncomeId;
            ChildParentIncomeRepository.invalidate(childParentIncomeId)
                .then(() => {
                    this.$notify.info('Die Einkommenstabelle wurde ungültig erklärt.', {}, { saveInSession: true });
                    this.redirectToShow();
                })
                .catch((error) => {
                    this.error = error;
                    this.$notify.error('saveChanges.error');
                    this.pendingId = null;
                });
        },
        addExpandedId(childParentIncomeId) {
            this.expandedIds.push(childParentIncomeId);
        },
        removeExpandedId(childParentIncomeId) {
            this.expandedIds.splice(this.expandedIds.indexOf(childParentIncomeId), 1);
        },
        isExpanded(childParentIncomeId) {
            return this.expandedIds.includes(childParentIncomeId);
        },
        toggle(childParentIncomeId) {
            if (this.expandedIds.includes(childParentIncomeId)) {
                this.removeExpandedId(childParentIncomeId);
            } else {
                this.addExpandedId(childParentIncomeId);
            }
        },
        initExpandedIds() {
            const clones = [...this.childParentIncomes];
            const first = clones.shift();
            this.addExpandedId(first.id);
        },
        isPending(childParentIncomeId) {
            return this.pendingId === childParentIncomeId;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    table thead tr.head th:first-child {
    width: 40%;
}
table thead tr.head th:nth-child(2) {
    width: 30%;
}
.sum {
    font-weight: var(--kgr-font-weight-bold);
}

tr.sum td:first-child {
    text-align: right;
}
td.button {
    text-align: right;
    padding: 0 15px 15px 0;
}
</style>
